import { SendMessageFunction } from "@/commons/models/Message";
import { SenderType } from "@/commons/services/Families";
import { LineReceiverDetail } from "@/commons/models/SendLineMessage";
import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileMessageHistoryState {
  facilityId: number;
  senderType: SenderType;
  datetime: number;
  receivers: string;
  functionContents: SendMessageFunction | any;
  writerId: string;
  writtenBy: string;
  unreadCount?: number;
  replyUnread?: boolean;
  receiverDetails: Array<LineReceiverDetail>;
  exist: boolean;
}

/**
 * ### MobileMessageHistory store
 *
 * - store
 *   - メッセージ履歴のメッセージ情報を保持する
 * - action, mutation
 *   - メッセージ履歴のメッセージ情報を格納する
 */
@Module({ name: "mobileMessageHistory" })
export default class MobileMessageHistory extends VuexModule implements MobileMessageHistoryState {
  facilityId = -1;
  senderType = -1;
  datetime = -1;
  receivers = "";
  functionContents = {};
  writerId = "";
  writtenBy = "";
  unreadCount = -1;
  replyUnread = false;
  receiverDetails = [];
  exist = false;

  /** stateのgetters */
  get mobileMessageHistoryState(): MobileMessageHistoryState {
    const state: MobileMessageHistoryState = {
      facilityId: this.facilityId,
      senderType: this.senderType,
      datetime: this.datetime,
      receivers: this.receivers,
      functionContents: this.functionContents,
      writerId: this.writerId,
      writtenBy: this.writtenBy,
      unreadCount: this.unreadCount,
      replyUnread: this.replyUnread,
      receiverDetails: this.receiverDetails,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILEMESSAGEHISTORYSTATE(state: MobileMessageHistoryState) {
    this.facilityId = state.facilityId;
    this.senderType = state.senderType;
    this.datetime = state.datetime;
    this.receivers = state.receivers;
    this.functionContents = state.functionContents;
    this.writerId = state.writerId;
    this.writtenBy = state.writtenBy;
    this.unreadCount = state.unreadCount != undefined ? state.unreadCount : -1;
    this.replyUnread = state.replyUnread != undefined ? state.replyUnread : false;
    this.receiverDetails = state.receiverDetails as never[];
    this.exist = true;

    return;
  }

  @Mutation
  private RESET_MOBILEMESSAGEHISTORYSTATE() {
    this.facilityId = -1;
    this.senderType = -1;
    this.datetime = -1;
    this.receivers = "";
    this.functionContents = {};
    this.writerId = "";
    this.writtenBy = "";
    this.unreadCount = -1;
    this.replyUnread = false;
    this.receiverDetails = [];
    this.exist = false;

    return;
  }

  /**
   * ### メッセージ履歴のメッセージ情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileMessageHistoryState(payload: { state: MobileMessageHistoryState }): void {
    this.SET_MOBILEMESSAGEHISTORYSTATE(payload.state);

    return;
  }

  /**
   * ### メッセージ履歴のメッセージ情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileMessageHistoryState(): void {
    this.RESET_MOBILEMESSAGEHISTORYSTATE();

    return;
  }
}
